export default {
  skipUploadingPhotos: 'Skip uploading photos',
  reasonForVisit: {
    title: 'REASON FOR VISIT',
    titleVideoVisit: 'REASON FOR VIDEO VISIT',
    selectReasonForVisit: 'Select a reason for visit',
    whatForSymptom: 'What for? (fever, sore throat, sprain, etc.)',
    dose1: 'Dose 1',
    dose2: 'Dose 2',
  },
  haveYouBeenHereBefore: {
    title: 'HAVE YOU BEEN TO {{location_name}} BEFORE?',
  },
  isThisAFamilyVisit: {
    title: 'IS THIS A FAMILY VISIT?',
    howManyTotalPatients: 'How many total patients need to be seen by a provider?',
    maximumPermitted: 'Maximum permitted',
  },
  userProfileAndPatientInfo: {
    title: 'PATIENT INFO',
    whoIsThisAppointmentFor: 'WHO IS THIS APPOINTMENT FOR',
    legalFirstName: 'Legal first name',
    patientFirstName: 'Patient first name',
    legalLastName: 'Legal last name',
    patientLastName: 'Patient last name',
    birthMonth: 'Birth month',
    mobileNumber: 'Mobile number',
    emailAddress: 'Email address',
    emailAddressOptional: 'Email address (optional)',
    homeAddressSeparateFields: {
      streetAddress: 'Street Address',
      aptSuiteEtcOptional: 'Apt, Suite, etc. (optional)',
      city: 'City',
      state: 'State',
      zipCode: 'ZIP code',
    },
    homeAddress: 'HOME ADDRESS',
    enterYourAddressHere: 'Enter your address here',
  },
  pay: {
    howDoYouWantToPay: 'HOW DO YOU WANT TO PAY?',
    howDoYouWantToPayAsterisk: 'HOW DO YOU WANT TO PAY?*',
  },
  telemedToggle: {
    whatTypeVisitDoYouWant: 'WHAT TYPE OF VISIT WOULD YOU LIKE TO BOOK?',
    inPersonVisit: 'In-Person Visit',
    videoVisit: 'Video Visit',
    connectWithProviderAtHome:
      'Connect with a provider at {{location_name}} in the comfort of home.',
    bookAVideoVisit: 'Book a Video Visit',
  },
  noAvailabilityTodayBanner: {
    walkInOnlyForRestOfToday: 'Walk-in only for the rest of today',
    noOnlineAvailabilityCanStillWalkIn:
      "There's no online availability today, but you can still walk in!",
  },
  insurancePricingFootnote: {
    doesntAcceptMedicareMedicaid: "This clinic doesn't accept Medicare or Medicaid.",
    doesntAcceptMedicaid: "This clinic doesn't accept Medicaid.",
    doesntAcceptMedicare: "This clinic doesn't accept Medicare.",
    acceptInsuranceMayVary:
      'If you select insurance, your responsibility will vary depending on your plan.',
    selfPayIsFlatRateOf: 'Self-pay is a flat rate of {{price}}.',
    youCanUseOtherInsurance: 'You can still book with this clinic and use another insurance.',
  },
  util: {
    selfPay: 'Self-Pay',
    insurance: 'Insurance',
    decideLater: 'Decide Later',
    bookingEllipsis: 'Booking...',
    checkingCoverageEllipsis: 'Checking Coverage...',
  },
  footNotes: {
    bookingsBySolv: 'Bookings by Solv.',
    forEmergenciesCall911: 'For emergencies <1>please call 911</1>',
  },
  openClosedStatusText: {
    opens: 'Opens',
    open24Hours: 'Open 24 hours',
    openNow: 'Open now',
    openWalkInOnly: 'Open now - Walk in only',
    openingSoon: 'Opening soon',
    closed: 'Closed',
    closedForLunchTimes: 'Closed for lunch daily from 1pm to 2pm',
    nextOpenDayAndTime: 'Opens {{time_of_day}} {{day_of_week}}',
  },
  logInToYourSolvAccount: '<1>Log in</1> to your Solv account.',
  visitTimeDisclaimer: {
    disclaimer:
      'This is your estimated time. Delays may arise if {{location_name}} is unexpectedly busy.',
  },
  appointmentRecapCard: {
    withinMinute: 'Within {{count}} minute',
    withinMinute_plural: 'Within {{count}} minutes',
  },
  chooseDateAndTime: 'CHOOSE A DATE AND TIME',
  consentLabel: {
    giveTelemedConsent:
      'I give my consent for the use of telemedicine in my medical care and have read, understand, and agree to these <1>Terms</1>',
  },
  openingHoursFormatter: {
    hourToHour: '{{start_time}} to {{end_time}}',
    midnight: 'midnight',
  },
  chooseATime: 'Choose a Time',
  messageFromTheClinic: 'Message from the clinic',
};
